module.exports = __webpack_public_path__ + "media/images/icons/material/twitter-0402026be0f7e5c885eab26af94b9468.svg";